import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule,Http } from '@angular/http';

import { bookrouts } from './book.routes';
import {InfoBoxContentComponent} from "../component/map/info-box-content.component";

import {CompanyService} from "../services/company-service/company-service";
import {CategoryService} from "../services/category/category.service";
//import {SearchSpaceComponent} from "../component/search-space/search-space.component";
//import {SpaceItemComponent} from "../component/space-item/space-item.component";
import {ShareModule} from "../share/share.module";
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from "ng2-translate";
import {BookComponent} from "./book.component";
import {BookToolbarComponent} from "../component/book-toolbar/book-toolbar.component";
import {BookToolbarV2Component} from "../component/book-toolbar-v2/book-toolbar-v2.component";
import {PageSliderModule}    from 'ng2-page-slider';
import {ServiceProfileModernComponent} from "../component/service-profile-modern/service-profile-modern.component.ts";
import {ServiceProfileComponent} from "../component/service-profile/service-profile.component.ts";
import { SwiperModule } from 'angular2-useful-swiper';
//import {SpaceAmenitiesComponent} from "../component/space-amenities/space-amenities.component";

import {DurationSelectorComponent} from "../component/duration-selector/duration-selector.component";
import {PriceLabelComponent} from "../component/price-label/price-label.component";
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {ParticipantInfoComponent} from "../component/participant-info/participant-info.component";
import { LoadingModule } from 'ngx-loading';
import {IntakeFormComponent} from "../component/intake-form/intake-form.component";
import {IntakeFieldVM} from "../models/IntakeForm.model";
import {IntakeFieldComponent} from "../component/intake-form/intake-field.component";
import { FileUploader,FileUploadModule } from 'ng2-file-upload';
import {ServantService} from "../services/servant-service/servant-service";
import {SupportedCompanyInformationDialogComponent} from "../component/supported-company-information-dialog/supported-company-information-dialog.component";
import {LoginFormComponent} from "../component/login-form/login-form.component";
// import {LoginFormNoPassComponent} from "../component/login-form-nopass/login-form-nopass.component";
import {CustomerIntakeDataComponent} from "../component/customer-intake-data/customer-intake-data.component";
import {PermissionService} from "../services/permission/permission.service";

// import {PersonInfoComponent} from "../component/person-info/personInfo.component";
//import {BusyModule} from "../../../node_modules/angular2-busy/src/busy.module";
//import {BusyConfig} from "../../../node_modules/angular2-busy/src/busy-config";



export function TranslateStaticLoaderFun(http: Http) {
  return   new TranslateStaticLoader(http, '/assets/i18n-14011218n', '.json')
}

@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    ShareModule,
    SwiperModule,
    LoadingModule,
    FileUploadModule,
    //BusyModule.forRoot(
    //  <BusyConfig>{  message: 'لطفا منتظر باشید...', minDuration: 500}
    //
    // ),
    RouterModule.forChild(bookrouts),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory:TranslateStaticLoaderFun,
      deps: [Http]
    })
    //PageSliderModule
  ],
  providers: [CompanyService, CategoryService, OrderBagService,ServantService,PermissionService],
  entryComponents: [SupportedCompanyInformationDialogComponent],
  declarations: [
    BookComponent,
    BookToolbarComponent,
    BookToolbarV2Component,
    SupportedCompanyInformationDialogComponent,
    DurationSelectorComponent,
    PriceLabelComponent,
    //SpaceAmenitiesComponent,
    ServiceProfileModernComponent,
    ServiceProfileComponent,
    LoginFormComponent,
    IntakeFormComponent,
    IntakeFieldComponent,
    // LoginFormNoPassComponent,
    ParticipantInfoComponent,
    CustomerIntakeDataComponent

    // PersonInfoComponent

  ]
})
export class BookModule {
  public static routes = bookrouts;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+book/book.module.ts